module.exports = __webpack_public_path__ + "img/antes_despues_271.e728c55b.png";